angular.module('rjmNg.api').factory 'Autodash', [
  '$resource'
  'serviceUrl'
  '$q'
  (
    $resource
    serviceUrl
    $q
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      save: angular.extend {}, defaultParams,
        method: 'POST'
      status: angular.extend {}, defaultParams,
        method: 'GET'
        url: serviceUrl('/clients/:id/autodash/:jobId')

    autodashResource = $resource serviceUrl('/clients/:id/autodash'), {}, actions

    MAGENTO_VERSION =
      "1": "magento1_2020"
      "2": "magento2_2020"

    GUEST_CHECKOUT = "_oo"

    ###
    Infers what package this client needs for autodashing a magento db
    ###
    getMagentoAutodashPackage = (client) ->
      hasGuestCheckout = +client.properties.has_guest_checkout > 0
      magentoVersion = client.properties.magento_version or "1"


      magentoVersionSubstr = MAGENTO_VERSION[magentoVersion]
      customSuffix = ""
      customSuffix = GUEST_CHECKOUT if hasGuestCheckout

      return magentoVersionSubstr+customSuffix

    Autodash =
      getMagentoAutodashPackage: getMagentoAutodashPackage

      queue: (clientId, payload) ->
        autodashResource.save({id: clientId}, payload).$promise

      status: (id, jobId) ->
        autodashResource.status({id, jobId}).$promise

      queueMagentoAutodash: (client, userId, metaId) ->
        payload =
          user_id: userId
          connections:
            db:
              connection_id: metaId
              database: client.properties.magento_store_db_name
              table_prefix: client.properties.magento_store_table_prefix
          package: getMagentoAutodashPackage(client)

        @queue(client.id, payload)

    Autodash

]
